<template>
    <div class="menu-container" >
        <div class="fashion-menu-wrap box" >
            <div class='fashion-menu'>
                <draggable v-model="list">
                    <div class="menu-item margin-top" v-for="(item, index) in list">
											<i class="el-icon-rank move"></i>
											<span class="bold">名称：</span><input type="text" v-model="item.name">
											<span class="bold">开关：</span>
											<el-switch
												v-model="item.status"
												active-color="#13ce66"
												inactive-color="#ff4949">
											</el-switch>
											<i class="el-icon-delete margin-left" @click="deleteCategory(index)"></i>
											<span class="bold ml-10">ID:</span>{{item.categoryId}}
                    </div>
                </draggable>
                <div class="margin-top">
                    <i class="el-icon-plus font-size" @click="addCategory"></i>
                </div>
                <div class="menu-footer margin-top">
                    <el-button type="primary" @click="doSave">提交</el-button>
                    <el-button type="danger" @click="goBack">返回</el-button>
                </div>
            </div>
        </div>

    </div>
</template>
<script type="text/babel">
    import draggable from 'vuedraggable';
    export default {
        components:{ draggable },
        data(){
            return {
                list:[],
            }
        },
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                HttpRequest.get('/admin.php?method=icy.getMediaCategoryList').then(response => {
                    this.list = _.toArray(response.data.list)
                    this.list.forEach((item)=>{
                        item.status=item.status==1?true:false;
                    })
                })
            },
            doSave(){
                let params=JSON.parse(JSON.stringify(this.list))
                params.forEach((item,index)=>{
                  item.status=item.status?1:0;
                  item.sort=params.length-1-index
                })
                for(let k in params){
                    if(!params[k].name){
                        this.$message("名称不能为空!");
                        return false;
                    }
                }
                HttpRequest.post('/admin.php?method=icy.doSaveMediaCategory',{categories:params}).then(response => {
                    if(response.data.success==0){
                        this.$message("保存成功")
                    }
                })
            },
            goBack(){
                window.open("/admin.php?method=icy.showStyles")
            },
            deleteCategory(index){
                if(confirm("确认要删除吗")){
                    this.list.splice(index,1)
                }
            },
            addCategory(){
                this.list.push({
                    'categoryId':0,
                    'name':"",
                    'sort':0,
                    'status':true,
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .fashion-menu {
      font-size: 16px;
    }
    .font-size {
      font-size: 30px;
    }
    .margin-top {
      margin-top: 15px;
    }
    .move {
      cursor: move;
    }
    .bold {
			font-weight: bold;
			color: #000;
		}
		.ml-10 {
			margin-left: 10px;
		}
</style>
